/**
 * "Something behind a badge moved — re-read it." One signal for every badge
 * (Mesajlar, Bildir, Profil) and the notification list.
 *
 * Two sources feed it: this tab, right after its own read call succeeds, and the
 * socket's badges:changed, for reads done in another tab or on another device.
 * Badges listen here instead of each waiting for its own poll.
 */

export interface BadgesChanged {
  /** Notification rows that no longer exist. */
  removedIds?: string[];
}

const EVENT = 'app:badges-changed';

export const signalBadgesChanged = (detail: BadgesChanged = {}): void => {
  window.dispatchEvent(new CustomEvent<BadgesChanged>(EVENT, { detail }));
};

export const onBadgesChanged = (listener: (detail: BadgesChanged) => void): (() => void) => {
  const handle = (event: Event) => listener((event as CustomEvent<BadgesChanged>).detail ?? {});
  window.addEventListener(EVENT, handle);
  return () => window.removeEventListener(EVENT, handle);
};
